import axios from '@/util/requestUtil'
class FundRecord {
  // 查询客户资金记录
  getDepositRecords (params) {
    return axios.get('/fund/fund-records', { params: params })
  }
}

export default new FundRecord()
